import { FileTypeKey } from "../enums/FileTypeKey";

export const getFileTypeKey = fileName => {
    const supportedImageFileFormats =
        ['gif', 'jpeg', 'jpg', 'png', 'svg', 'webp', 'cur', 'bmp',
            // 'psd', 'tiff', 'jp2' -- unsupported
        ]; //image

    const supportedVideoFileFormats =
        ['mp4', 'ogg', 'webm',
            // 'avi', 'flv', 'wmv', 'mov' -- unsupported
        ]; // video

    // const file_extension = f.file.filename?.substr(f.file.filename.lastIndexOf('.') + 1).toLowerCase();

    const fileExtension = fileName?.split('.').pop().toLowerCase();

    if (fileExtension?.includes('pdf'))
        return FileTypeKey.PDF;
    if (supportedImageFileFormats.includes(fileExtension))
        return FileTypeKey.IMAGE;
    if (supportedVideoFileFormats.includes(fileExtension))
        return FileTypeKey.VIDEO;
    return FileTypeKey.UNSUPPORTED;
};
